/**
 * Never edit this file manually. It is generated as part of the building process
 */
export const AppInfo = {
    name: 'medion-alditalk-client',
    appName: 'medion-alditalk-client',
    version: '2.19.2' ,
    defaultLocale: 'de',
    di18nMode: 'TRANSLATE',
    git: {
        shortHash: '5c752ae',
        hash: '5c752ae435856921bed6f593deeb4a2af46e6b35',
        subject: 'Merge branch \'next\' into \'master\'',
        sanitizedSubject: 'Merge-branch-next-into-master',
        authoredOn: '1793009834',
        committedOn: '1793009834',
        branch: 'HEAD',
    }
};

